<div mat-dialog-title class="d-flex align-items-center">
  <div class="d-flex align-items-center w-100">
    <img alt="g-modal-image" *ngIf="true" src="./assets/icons/pagar_tesoreria.svg" class="dhl-dialog-img" />
    <h2 color="red" class="dhl-dialog-title">{{ dialogData.title ? dialogData.title : 'Confirmar' }}</h2>
  </div>
  <div class="flex-shrink-1">
    <div class="position-absolute top-0 end-0 p-2">
      <button mat-icon-button [mat-dialog-close]="false" color="accent">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="row">
    <div class="col" [innerHTML]="dialogData.message"></div>
  </div>
  <div [formGroup]="montoFormGroup">
    <div class="row mt-5">
      <div class="col col-md-8 mx-auto">
        <mat-form-field>
          <mat-label>Monto a pagar</mat-label>
          <input matInput formControlName="monto" (keypress)="filterNumericInput($event)" (input)="formatCurrencyInput()" />
          <mat-hint color="red" *ngIf="isEqualsBalnce">La cantidad ingresada debe ser igual al adeudo </mat-hint>
          <mat-error *ngIf="montoFormGroup.controls['monto'].hasError('required')">El monto es obligatorio</mat-error>
          <mat-error *ngIf="montoFormGroup.controls['monto'].hasError('pattern')">Formato de monto inválido</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col col-md-8 mx-auto">
        <mat-form-field>
          <mat-label>Motivo de pago:</mat-label>
          <textarea matInput formControlName="motivo" maxlength="250"></textarea>
          <mat-error *ngIf="montoFormGroup.controls['motivo'].hasError('required')">El motivo es obligatorio</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button
    *ngIf="dialogData.showCancel"
    mat-stroked-button
    color="accent"
    (click)="onCancel()"
    class="dhl-btn-secundary"
    [innerHTML]="dialogData.cancelLabel ? dialogData.cancelLabel : 'Cancelar'"></button>
  <button
    *ngIf="dialogData.showAccept"
    mat-flat-button
    cdkFocusInitial
    color="accent"
    (click)="showModalCarryInfo()"
    class="dhl-btn-primary"
    [disabled]="!montoFormGroup.valid || isEqualsBalnce">
    {{ dialogData.acceptLabel ? dialogData.acceptLabel : 'Aceptar' }}
  </button>
</div>
